import React from 'react';
import { Typography, makeStyles } from '@material-ui/core';
import { CSSProperties } from '@material-ui/core/styles/withStyles';

const useStyles = makeStyles(theme => ({
  item: {
    margin: theme.spacing(2, 0),

    '&:before': {
      content: '""',
      display: 'inline-block',
      paddingRight: '10px',
      verticalAlign: 'middle',
      width: '24px',
      height: '24px',
      background: 'url("/img/components/arrow-list-item/right-arrow.svg") no-repeat',
      backgroundSize: '24px 24px',
      boxSizing: 'content-box',
    },
  },
}));

interface Props {
  children?: any;
  style?: CSSProperties;
}

const ArrowListItem: React.FC<Props> = props => {
  const classes = useStyles();
  return (
    <Typography variant="h6" className={classes.item} style={props.style}>
      {props.children}
    </Typography>
  );
};

export default ArrowListItem;
